import { computed } from 'vue';
import { usePermissionStore } from './permission.store';
import type { CaslAction, Subjects } from '@/shared/lib/casl';

export function usePermission() {
  const store = usePermissionStore();

  const can = (action: CaslAction, subject: Subjects) => {
    return computed(() => store.can(action, subject));
  };

  const cannot = (action: CaslAction, subject: Subjects) => {
    return computed(() => store.cannot(action, subject));
  };

  const canAny = (...checks: [CaslAction, Subjects][]) => {
    return computed(() => checks.some(([action, subject]) => store.can(action, subject)));
  };

  const canAll = (...checks: [CaslAction, Subjects][]) => {
    return computed(
      () => checks.length > 0 && checks.every(([action, subject]) => store.can(action, subject))
    );
  };

  return {
    can,
    cannot,
    canAny,
    canAll,
    isLoaded: computed(() => store.isLoaded),
  };
}
